import videojs from 'video.js';

export class ImageOverlay extends videojs.getComponent('Component') {
  constructor(player, options) {
    super(player, options);
    this.on(player, 'player:will-set-variant', (_, { variant }) => {
      this.update(variant);
    });
    this.el().classList.add('wrp-player-image-overlay');
  }

  update(variant = {}) {
    this.clear();
    if (variant.is_placeholder && variant.image) {
      const image = document.createElement('img');
      image.src = variant.image.url;
      image.srcset = Object.entries(variant.image.srcset)
        .map(([width, url]) => `${url} ${width}w`)
        .join(', ');
      this.el().appendChild(image);
    }
  }
  clear() {
    this.el().innerHTML = '';
  }
}
